import React from 'react';

import Popover from './Popover';
import ChildNavItem from './ChildNavItem';

const PopoverNav = ({ items, columns, ...props }) => {
  if (items.length <= 0 && columns.length <= 0) return null;

  if (columns.length > 0)
    return (
      <Popover {...props} grow>
        <div className="lg:flex lg:flex-no-wrap lg:py-2 lg:pt-3" role="menu">
          {columns.map((column, index) => (
            <div key={index} className="lg:w-64 h-full">
              <h4 className="px-2 lg:px-5 py-1 lg:py-0 lg:mb-3 font-bold text-sm uppercase tracking-wide text-rose lg:text-rose">
                {column.label}
              </h4>

              <ul>
                {column.items.map((item, index) => (
                  <li role="menuitem" key={index}>
                    <ChildNavItem key={index} {...item} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </Popover>
    );

  return (
    <Popover {...props}>
      {items.map((item, index) => (
        <ChildNavItem key={index} {...item} />
      ))}
    </Popover>
  );
};

export default PopoverNav;
